import React from 'react'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import StateComponents from '../../../../components/state-component/StateComponents';
import { ManageStateDetail } from './manageStateDetail';
import PermissionCustom from './PermissionCustom';
import ContainerButton from '../../../../components/button/ContainerButton';
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom';
import { routeName } from '../../../../routes/routeName';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import { useTranslation } from 'react-i18next';

type Props = {
    view: boolean;
}

const PermissionDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate: NavigateFunction = useNavigate();
    const {
        permission_data,
        handleCheckAllPermit,
        handleCheckMain,
        handleSubmit,
        handleCheckMainPermit,
        handleCheckSub,
        handleCheckSubPermit,
        errorMessage,
        form_roles,
        handleChange,
        handleCheckThreeSub,
        handleCheckThreeSubPermit
    } = ManageStateDetail();

    return (
        <ContainerLayout
            title={t('เพิ่มบทบาท')}
            // navigationList={
            //     <NavigateListCustom
            //         navigateData={[
            //             {
            //                 key: "CONTRACT",
            //                 name: "ตั้งค่า",
            //                 pathName: routeName.cms.permission,
            //             },
            //             {
            //                 key: "CONTRACT",
            //                 name: "บทบาทผู้ใช้งาน",
            //                 pathName: routeName.cms.permission,
            //             },
            //             ...(id ? [
            //                 {
            //                     key: "CONTRACT",
            //                     name: "รายละเอียดบทบาท",
            //                     pathName: view ? routeName.cms.permissionDetailView.replace(":id", id) : routeName.cms.permissionDetail.replace(":id", id),
            //                 },
            //             ] : [
            //                 {
            //                     key: "CONTRACT",
            //                     name: "เพิ่มบทบาท",
            //                     pathName: routeName.cms.permissionCreate,
            //                 },
            //             ])
            //         ]}
            //     />
            // }
            content={
                <div className='px-4'>
                    <StateComponents
                        disabledAllField={view}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    heading: t("ชื่อบทบาท"),
                                    required: true,
                                    placeholder: t("ระบุชื่อบทบาท"),
                                    helperText: errorMessage.role_name,
                                    value: form_roles.role_name,
                                    onChange: (e) => handleChange('role_name', e.target.value)
                                },
                            },
                            // {
                            //     seq: 2,
                            //     type: "COMPONENT",
                            //     gridProps: {
                            //         xs: 12,
                            //         md: 4
                            //     },
                            //     fieldProps: {
                            //         element: (
                            //             <div className='flex gap-4 my-6'>
                            //                 <CheckBoxCustom
                            //                     label='เป็นหัวหน้าช่าง'
                            //                     disabled={view}
                            //                     checked={form_roles.is_supervisor}
                            //                     setChecked={(st) => handleChange('is_supervisor', st)}
                            //                 />
                            //                 <CheckBoxCustom
                            //                     label='เป็นช่าง'
                            //                     disabled={view}
                            //                     checked={form_roles.is_engineer}
                            //                     setChecked={(st) => handleChange('is_engineer', st)}
                            //                 />
                            //                 <CheckBoxCustom
                            //                     label='เป็น ผจก.ธุรการ'
                            //                     disabled={view}
                            //                     checked={form_roles.is_admin_manager}
                            //                     setChecked={(st) => handleChange('is_admin_manager', st)}
                            //                 />
                            //             </div>
                            //         )
                            //     }
                            // }
                        ]}
                    />

                    <PermissionCustom
                        disabled={view}
                        permission_data={permission_data || []}
                        checkAll
                        onCheckMain={(main_index: number, action_index: number, status: boolean) => handleCheckMain(main_index, action_index, status)}
                        onCheckAll={(status) => handleCheckAllPermit(status)}
                        onCheckMainPermit={(main_index: number, status: boolean) => handleCheckMainPermit(main_index, status)}
                        onCheckSub={(main_index: number, sub_index: number, action_index: number, status: boolean) => handleCheckSub(main_index, sub_index, action_index, status)}
                        onCheckSubPermit={(main_index: number, sub_index: number, status: boolean) => handleCheckSubPermit(main_index, sub_index, status)}
                        onCheckThreeSubPermit={handleCheckThreeSubPermit}
                        onCheckThreeSub={handleCheckThreeSub}
                    />

                    <ContainerButton
                        sxContainer={{ my: 10 }}
                        buttonData={[
                            {
                                seq: 1,
                                buttonProps: {
                                    onClick: () => navigate(routeName.cms_website.permission)
                                },
                                key: "BACK",
                                label: t("ย้อนกลับ"),
                                type: 'CANCEL'
                            },
                            {
                                seq: 2,
                                hidden: view,
                                buttonProps: {
                                    onClick: () => handleSubmit()
                                },
                                key: "SAVE",
                                label: t("บันทึก"),
                                type: "SAVE"
                            },
                        ]}
                    />
                </div>
            }

        />
    )
}

export default PermissionDetail